import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider";
import { ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./auth/PrivateRoute";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/dashboard";
import UploadPage from "./pages/uploadPage";
import UserPage from "./pages/userPage";
import AddUserPage from "./pages/addUser";
import MonitoringReport from "./pages/monitoring-report";
import ExportPage from "./pages/exportPage";
import StateDetailsPage from "./pages/stateDetailsPage";

function App() {
  return (
    <>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <DashboardPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/uploads"
              element={
                <PrivateRoute>
                  <UploadPage />
                </PrivateRoute>
              }
            />

            <Route
              path="/export"
              element={
                <PrivateRoute>
                  <ExportPage />
                </PrivateRoute>
              }
            />

            <Route
              path="/state-details"
              element={
                <PrivateRoute>
                  <StateDetailsPage />
                </PrivateRoute>
              }
            />

            <Route
              path="/users"
              element={
                <PrivateRoute>
                  <UserPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/adduser"
              element={
                <PrivateRoute>
                  <AddUserPage />
                </PrivateRoute>
              }
            />
            <Route path="*" element={<LoginPage />} />
            <Route path="monitoring-report" element={<MonitoringReport />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
